import { css, html } from "../helpers/webComponents";

//  CSS styles for the map component.
const styles: string = css`
  .map-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    display: none;
    color: black;
  }

  .map-modal h2 {
    margin-bottom: 10px;
  }

  .map-modal p {
    margin-bottom: 5px;
  }

  .map-modal button {
    margin-top: 10px;
  }
`;

export class MapDisplayComponent extends HTMLElement {
// property to store the message to be displayed in the modal
    private message: string = "";

    // method called when the component is added to the DOM
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    // Method to set the message to be displayed in the modal.
    public setMessage(message: string): void {
        this.message = message;
        this.render();
    }

    // Method to show the modal.
    public show(): void {
        const modal: HTMLElement = this.shadowRoot!.querySelector(".map-modal") as HTMLElement;
        modal.style.display = "block";
    }

    // Method to hide the modal.
    public hide(): void {
        const modal: HTMLElement = this.shadowRoot!.querySelector(".map-modal") as HTMLElement;
        modal.style.display = "none";
    }

    // Method to render the component's content.
    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        // Create the modal element using
        const modalElement: HTMLElement = html`
      <div class="map-modal">
        <h2>Map Check Results</h2>
        <div id="map-result-message"></div>
        <button id="map-modal-close">Close</button>
      </div>
    `;

        // Create the style element
        const styleElement: HTMLElement = html`<style>${styles}</style>`;
        const elements: HTMLElement[] = [styleElement, modalElement];

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
        this.updateMessageDisplay();
        this.addEventListeners();
    }

    // Method to update the message display in the modal.
    private updateMessageDisplay(): void {
        const messageDiv: Element | null = this.shadowRoot!.querySelector("#map-result-message");
        if (messageDiv) {
            messageDiv.innerHTML = this.message;
        }
    }

    // Method to add event listeners to the modal's elements.
    private addEventListeners(): void {
        const closeButton: Element | null = this.shadowRoot!.querySelector("#map-modal-close");
        if (closeButton) {
            closeButton.addEventListener("click", () => this.hide());
        }
    }
}

customElements.define("map-display", MapDisplayComponent);
